import {di} from "@dp-instant/core";
import {TypesFlow, TypesSocial, TypesCore} from "@dp-instant/interfaces";
import {LevelStartAction} from "@dp-instant/gameflow";
import {SOCIAL_POPUP, ISocial} from "@dp-instant/social";
import {IEventEmitter} from "@dp-instant/interfaces";
import {Button, UIEvents} from "@dp-instant/ui";
import {IClickableComponentProps} from "@game/ui/interface/IClickableComponentProps";
import {TypesGame} from "@game/TypesGame";
import cn from "classnames";
//@ts-ignore
import * as FBInstant from "fb-sdk-wrapper";
import {playUIClickSound} from "@game/helpers";
import {hapticMedium} from "@game/haptic";

export const InviteButton = (
    props: IClickableComponentProps & {options?: FBInstant.ContextOptions}
) => (
    <Button
        icon="friends"
        className={cn("btn-blue")}
        onClick={async () => {
            playUIClickSound();
            hapticMedium();
            if (__SOCIAL__ === "tg") {
                const dispatcher: IEventEmitter = di.get(TypesCore.dispatcher);
                dispatcher.emit(UIEvents.SCREEN_CHANGED, {
                    id: TypesGame.screens.referral,
                    props: {}
                });
            } else {
                const social: ISocial = di.get(TypesSocial.model);
                const status = await social.invite(props.options, false);
                switch (status) {
                    case SOCIAL_POPUP.ACCEPTED:
                        const levelStartAction = di.get<LevelStartAction>(TypesFlow.LevelStart);
                        await levelStartAction.run();
                        break;
                    case SOCIAL_POPUP.CANCELLED:
                        break;
                }
            }
            props.onClick && props.onClick();
        }}
    />
);
